import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VisibilityService } from './visibility.service';
import { AlwaysVisibilityService } from './rule-services/always-visibility-rule.service';
import { NeverVisibilityService } from './rule-services/never-visibility-rule.service';
import { HasActiveTourVisibilityService } from './rule-services/has-active-tour-visibility-rule.service';
import { HasNoActiveTourVisibilityService } from './rule-services/has-no-active-tour-visibility-rule.service';
import { HasVIPOnTourVisibilityService } from './rule-services/has-vip-on-tour-visibility-rule.service';
import { VisibilityRuleService } from './visibility-rule-service';
import { BranchHasPhotodocuPhotos } from './rule-services/branch-has-photdocu-photos.service';
import { HasPeripheralsVisibilityService } from './rule-services/has-peripherals-rule.service';
import { NeedsAppGPSVisibilityService } from './rule-services/needs-app-gps-visibility-rule.service';
import { IsPassengerVisibilityService } from './rule-services/is-passenger-visibility-rule.service';
import { SjobTypeVisibilityService } from './rule-services/sjob-type-visibility-rule.service';
import { IsNotPassengerVisibilityService } from './rule-services/is-not-passenger-visibility-rule.service';
import { IsNormalTourVisibilityService } from './rule-services/is-normal-tour-visibility-rule copy';
import { IsQuickTourVisibilityService } from './rule-services/is-quick-tour-visibility-rule';
import { NeedsCashingVisibilityService } from './rule-services/needs-cashing-visibility-rule';
import { CanDoSteeringBreakVisibilityService } from './rule-services/can-do-steering-break-visibility-rule.service';
import { CanDoRestingVisibilityService } from './rule-services/can-do-resting-break-visibility-rule.service';
import { IsOnSteeringBreakVisibilityService } from './rule-services/is-on-steering-break-visibility-rule.service';
import { IsOnRestingBreakVisibilityService } from './rule-services/is-on-resting-break-visibility-rule.service';
import { HasDeliveryItemsVisibilityService } from './rule-services/has-delivery-items-visibility-rule';
import { HasReturnItemsVisibilityService } from './rule-services/has-return-items-visibility-rule';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    VisibilityService,
    {
      provide: VisibilityRuleService,
      useClass: AlwaysVisibilityService,
      multi: true,
    },
    {
      provide: VisibilityRuleService,
      useClass: NeverVisibilityService,
      multi: true,
    },
    {
      provide: VisibilityRuleService,
      useClass: HasActiveTourVisibilityService,
      multi: true,
    },
    {
      provide: VisibilityRuleService,
      useClass: HasNoActiveTourVisibilityService,
      multi: true,
    },
    {
      provide: VisibilityRuleService,
      useClass: HasVIPOnTourVisibilityService,
      multi: true,
    },
    {
      provide: VisibilityRuleService,
      useClass: BranchHasPhotodocuPhotos,
      multi: true,
    },
    {
      provide: VisibilityRuleService,
      useClass: HasPeripheralsVisibilityService,
      multi: true,
    },
    {
      provide: VisibilityRuleService,
      useClass: NeedsAppGPSVisibilityService,
      multi: true,
    },
    {
      provide: VisibilityRuleService,
      useClass: IsPassengerVisibilityService,
      multi: true,
    },
    {
      provide: VisibilityRuleService,
      useClass: IsNotPassengerVisibilityService,
      multi: true,
    },
    {
      provide: VisibilityRuleService,
      useClass: SjobTypeVisibilityService,
      multi: true,
    },
    {
      provide: VisibilityRuleService,
      useClass: IsNormalTourVisibilityService,
      multi: true,
    },
    {
      provide: VisibilityRuleService,
      useClass: IsQuickTourVisibilityService,
      multi: true,
    },
    {
      provide: VisibilityRuleService,
      useClass: NeedsCashingVisibilityService,
      multi: true,
    },
    {
      provide: VisibilityRuleService,
      useClass: CanDoSteeringBreakVisibilityService,
      multi: true,
    },
    {
      provide: VisibilityRuleService,
      useClass: CanDoRestingVisibilityService,
      multi: true,
    },
    {
      provide: VisibilityRuleService,
      useClass: IsOnSteeringBreakVisibilityService,
      multi: true,
    },
    {
      provide: VisibilityRuleService,
      useClass: IsOnRestingBreakVisibilityService,
      multi: true,
    },
    {
      provide: VisibilityRuleService,
      useClass: HasDeliveryItemsVisibilityService,
      multi: true,
    },
    {
      provide: VisibilityRuleService,
      useClass: HasReturnItemsVisibilityService,
      multi: true,
    },
  ],
})
export class VisibilityModule {}
